<template>
  <!-- Баннер 4a · живой HTML вместо картинки 1280×442, масштабируется под ширину карусели -->
  <div class="rb" ref="root">
    <div class="rb-stage" :style="{ transform: `scale(${k})` }">
      <div class="rb-glow"></div>

      <div class="rb-copy">
        <div class="rb-chip">РУЛЕТКА ПРИЗОВ</div>
        <div class="rb-title">PREMIUM<br />НА ГОД</div>
        <div class="rb-sub">Крутите за монетки ›</div>
      </div>

      <div class="rb-window">
        <div class="rb-mask">
          <div class="rb-reel">
            <div v-for="(it, i) in SEQ" :key="i" class="rb-row">
              <PrizeIcon :item="it" :scale="1.35" />
              <div class="rb-row-text">
                <div class="rb-kind">{{ it.label }}</div>
                <div class="rb-t1">{{ it.t1 }}</div>
                <div class="rb-t2">{{ it.t2 }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="rb-frame"></div>
      </div>

      <CoinIcon :size="110" class="rb-coin rb-coin-1" />
      <CoinIcon :size="84" class="rb-coin rb-coin-2" />
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue';
import PrizeIcon from './PrizeIcon.vue';
import CoinIcon from './CoinIcon.vue';

// Промо-последовательность: барабан прокручивается и останавливается на Premium 12 мес.
// 10 строк, сдвиг 7 × 172px — бесшовный цикл (строка 1 == строка 8).
const BASE = [
  { kind: 'tariff', plan: 'Basic', months: 6, label: 'ТАРИФ', t1: 'Basic', t2: '6 месяцев' },
  { kind: 'jackpot', plan: 'Premium', months: 12, label: 'ГЛАВНЫЙ ПРИЗ', t1: 'Premium', t2: '12 месяцев' },
  { kind: 'disc', target: 'Premium', percent: 30, minMonths: 1, label: 'СКИДКА', t1: '−30%', t2: 'на Premium' },
  { kind: 'coins', amount: 100, label: 'БОНУС', t1: '100', t2: 'монеток' },
  { kind: 'all', target: 'any', percent: 20, minMonths: 3, label: 'СКИДКА', t1: '−20%', t2: 'на все тарифы' },
  { kind: 'tariff', plan: 'Medium', months: 3, label: 'ТАРИФ', t1: 'Medium', t2: '3 месяца' },
  { kind: 'money', amount: 50, label: 'БОНУС', t1: '50 ₽', t2: 'на баланс' }
];
const SEQ = [...BASE, BASE[0], BASE[1], BASE[2]];

const root = ref(null);
const k = ref(0.26);
let ro = null;
const update = () => { if (root.value) k.value = root.value.offsetWidth / 1280; };

onMounted(() => {
  update();
  if ('ResizeObserver' in window) {
    ro = new ResizeObserver(update);
    ro.observe(root.value);
  } else {
    window.addEventListener('resize', update);
  }
});
onUnmounted(() => {
  if (ro) ro.disconnect();
  else window.removeEventListener('resize', update);
});
</script>

<style scoped>
.rb {
  position: relative; width: 100%; aspect-ratio: 1280 / 442; border-radius: 20px; overflow: hidden;
  background: #0F1512; user-select: none; -webkit-user-select: none;
}
.rb-stage { position: absolute; left: 0; top: 0; width: 1280px; height: 442px; transform-origin: 0 0; overflow: hidden; }
.rb-glow {
  position: absolute; right: -120px; top: -200px; width: 900px; height: 900px; border-radius: 50%;
  background: radial-gradient(circle, rgba(18,183,106,.5), transparent 62%);
}
.rb-copy { position: absolute; left: 72px; top: 64px; display: flex; flex-direction: column; gap: 18px; }
.rb-chip {
  align-self: flex-start; font-size: 26px; font-weight: 800; letter-spacing: .08em; color: #0F1512;
  background: #12B76A; padding: 10px 20px; border-radius: 14px;
}
.rb-title { font-size: 92px; font-weight: 800; letter-spacing: -.03em; line-height: .95; color: #fff; }
.rb-sub { font-size: 36px; font-weight: 600; color: #B9E8CF; }

.rb-window {
  position: absolute; right: 60px; top: 40px; width: 500px; height: 362px; border-radius: 40px;
  background: rgba(255,255,255,.06); border: 2px solid rgba(255,255,255,.1); overflow: hidden;
}
.rb-mask {
  position: absolute; inset: 0;
  -webkit-mask-image: linear-gradient(transparent, #000 30%, #000 70%, transparent);
  mask-image: linear-gradient(transparent, #000 30%, #000 70%, transparent);
}
.rb-reel { position: absolute; left: 0; right: 0; top: -77px; animation: bannerReel 5.5s infinite; will-change: transform; }
.rb-row { height: 172px; display: flex; align-items: center; gap: 26px; padding: 0 34px; box-sizing: border-box; }
.rb-row-text { display: flex; flex-direction: column; gap: 2px; }
.rb-kind { font-size: 18px; font-weight: 800; letter-spacing: .08em; color: #9FB0A7; }
.rb-t1 { font-size: 44px; font-weight: 800; letter-spacing: -.02em; color: #fff; line-height: 1.05; }
.rb-t2 { font-size: 24px; font-weight: 600; color: #B9E8CF; }
.rb-frame {
  position: absolute; left: 14px; right: 14px; top: 108px; height: 146px; border-radius: 32px;
  border: 4px solid #12B76A; box-sizing: border-box; pointer-events: none; animation: bannerFrame 5.5s infinite;
}

.rb-coin { position: absolute; }
.rb-coin-1 { right: 500px; top: 280px; animation: floaty 3.4s ease-in-out infinite; filter: drop-shadow(0 14px 20px rgba(0,0,0,.45)); }
.rb-coin-2 { right: 26px; top: 6px; animation: floaty2 3.8s ease-in-out infinite; filter: drop-shadow(0 10px 16px rgba(0,0,0,.45)); }

@keyframes bannerReel {
  0%, 42% { transform: translateY(0); filter: none; animation-timing-function: cubic-bezier(.3,.05,.1,1); }
  60% { filter: blur(2px); }
  86%, 100% { transform: translateY(-1204px); filter: none; }
}
@keyframes bannerFrame {
  0%, 84% { box-shadow: 0 0 30px rgba(18,183,106,.45); }
  90% { box-shadow: 0 0 80px rgba(18,183,106,.95), inset 0 0 30px rgba(18,183,106,.5); }
  100% { box-shadow: 0 0 30px rgba(18,183,106,.45); }
}
@keyframes floaty { 0%, 100% { transform: translateY(0) rotate(-8deg); } 50% { transform: translateY(-8px) rotate(-4deg); } }
@keyframes floaty2 { 0%, 100% { transform: translateY(0) rotate(10deg); } 50% { transform: translateY(6px) rotate(14deg); } }

@media (prefers-reduced-motion: reduce) {
  .rb-reel, .rb-frame, .rb-coin { animation: none; }
  .rb-reel { transform: translateY(0); }
}
</style>
